<div class="traffic-logs-collapsed-sidebar">
    <div class="traffic-logs-collapsed-sidebar__saved-search-section">
        <collapsed-sidebar-icon-list
            [iconNames]="searchSectionIconList"
        ></collapsed-sidebar-icon-list>
    </div>
    <div class="traffic-logs-collapsed-sidebar__data-section">
        <collapsed-sidebar-icon-list
            [iconNames]="dataSectionIconList"
        ></collapsed-sidebar-icon-list>
   </div>
</div>
